import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`PostHog's `}<a parentName="p" {...{
        "href": "/docs/feature-flags"
      }}>{`feature flags`}</a>{` enable you to safely deploy and roll back new features as well as target specific users and groups with them.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      